<!---->


<!-- -->
<div class="secondary-layout-container">
    <btx-secondary-empty-header></btx-secondary-empty-header>
    <!--    -->
    <div class="container secondary-layout-content">
        <router-outlet></router-outlet>
        <!--    -->
    </div>

    <div class="push"></div>
</div>
<btx-secondary-empty-footer id="footer"></btx-secondary-empty-footer>